









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ModuleIframe extends Vue {

    @Prop() module!: string
    @Prop() src!: string
    get showIframe(): boolean {
        return !this.$currentCompany.modules.includes(this.module)
    }
}
